import React from 'react';
import { SvgIcon } from '@material-ui/core'

const IcMail = (props) => (
  <SvgIcon
    viewBox="0 0 107.586 107.586"
    {...props}
  >
    <g transform="translate(-629 -403.326)">
      <ellipse 
        cx="53.793" 
        cy="53.793"
        rx="53.793" 
        ry="53.793" 
        transform="translate(629 403.326)" 
        fill="#efefef"
      />
      <path 
        d="M48.031,76.125a.576.576,0,0,1,.928.449V96.129a4.591,4.591,0,0,1-4.59,4.59H4.59A4.591,4.591,0,0,1,0,96.129V76.584a.572.572,0,0,1,.928-.449C3.069,77.8,5.91,79.912,15.663,87c2.018,1.473,5.422,4.571,8.816,4.552,3.414.029,6.885-3.136,8.826-4.552C43.059,79.912,45.889,77.789,48.031,76.125ZM24.479,88.48c2.218.038,5.412-2.792,7.019-3.959,12.689-9.208,13.655-10.012,16.581-12.307a2.288,2.288,0,0,0,.88-1.807V68.59A4.591,4.591,0,0,0,44.369,64H4.59A4.591,4.591,0,0,0,0,68.59v1.817a2.3,2.3,0,0,0,.88,1.807c2.926,2.285,3.892,3.1,16.581,12.307C19.067,85.687,22.261,88.518,24.479,88.48Z" 
        transform="translate(658.263 374.442)" 
        fill="#c7c7c7"
      />
    </g>
  </SvgIcon>
);

export default IcMail;